// src/config/api.ts or wherever you define endpoints

const BASE_URL = import.meta.env.VITE_BASE_URL;
const API_PATH = import.meta.env.VITE_API_PATH || '/api';

const buildUrl = (prefix: string) => `${BASE_URL}${prefix}${API_PATH}`;

export const API_ENDPOINTS = {
  auth: buildUrl(import.meta.env.VITE_AUTH_API_PREFIX || '/auth'),
  platform: buildUrl(import.meta.env.VITE_PLATFORM_API_PREFIX || '/platform'),
  project: buildUrl(import.meta.env.VITE_PROJECT_API_PREFIX || '/project'),
  common: buildUrl(import.meta.env.VITE_COMMON_API_PREFIX || '/common'),
  inventory: buildUrl(import.meta.env.VITE_INVENTORY_API_PREFIX || '/inventory'),
  payroll: buildUrl(import.meta.env.VITE_PAYROLL_API_PREFIX || '/payroll'),
  vehicle: buildUrl(import.meta.env.VITE_VEHICLE_API_PREFIX || '/vms'),
};

console.log('✅ Loaded from Environment:', API_ENDPOINTS);

if (!BASE_URL) {
  console.warn('⚠️ VITE_BASE_URL is not defined in environment variables');
}